import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useManualInputRows = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  return {
    minRows: 4,
    maxRows: isMobile ? 8 : 12,
  };
};

export default useManualInputRows;
